<template>
  <div>
    <label for="From">{{
      type == "start" ? $t("From") + "*" : $t("To")
    }}</label>
    <v-menu
      ref="menu2"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="timeValue"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timeValue"
          :rules="type == 'start' ? [validationRules.required] : []"
          prepend-inner-icon="access_time"
          readonly
          v-bind="attrs"
          v-on="on"
          solo
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu2"
        v-model="timeValue"
        full-width
        @click:minute="$refs.menu2.save(timeValue)"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "groupFromTimeComponent",
  mixins: [validationMixin],
  props: ["index", "DefaultFrom", "type"],

  data() {
    return {
      menu2: false,
      today: new Date().toISOString().substr(0, 10),
      timeValue: "",
    };
  },
  watch: {
    DefaultFrom: {
      handler() {
        if (this.DefaultFrom) {
          this.timeValue = this.DefaultFrom;
        } else {
          this.timeValue = "";
        }
      },
    },

    timeValue: {
      handler() {
        if (this.type == "start") {
          this.$emit("setFromValue", this.index, this.timeValue);
        } else if (this.type == "end") {
          this.$emit("setToValue", this.index, this.timeValue);
        }
      },
    },
  },
};
</script>

<style></style>
